module.exports = __webpack_public_path__ + "img/2.1cd7aa2.jpg";